import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';

import TelegramChatDemo from './TelegramChatDemo';
import settings from '../settings';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: '3rem',
    paddingBottom: '3rem',
    textAlign: 'center',
    maxWidth: 1200,
    margin: '0 auto',
  },
  header: {
    margin: '0 auto',
    maxWidth: 700,
    marginTop: 32,
  },
  showcase: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: 64,
    gap: 40,
    [`@media (max-width: ${settings.maxMobileWidth}px)`]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  demoContainer: {
    flex: 1,
    minWidth: 320,
  },
  stepperContainer: {
    flex: 1,
    minWidth: 320,
    textAlign: 'left',
  },
  cmd: {
    display: 'inline-block',
    padding: '6px 10px',
    backgroundColor: '#fff',
    color: '#0088cc',
    fontWeight: 'bold',
    borderRadius: 6,
  },
  stepLabel: {
    marginTop: '0.15rem',
    fontWeight: 'normal !important',
  },
}));

const Home = () => {
  const classes = useStyles();

  const steps = [
    {
      label: <>
        Add the bot
        {' '}
        <Link href={settings.telegram.bot.url}>
          {settings.telegram.bot.label}
        </Link>
        {' '}
        to your Telegram chat or open it privately</>,
    },
    {
      label: <>Use <b>/scan</b> with the image of a chess diagram</>,
      content: (
        <>
          <br />
          <Typography variant="body2">
            You can either:
          </Typography>

          <br />

          <Typography variant="body2">
            • send the image with a caption
            <code className={classes.cmd} style={{ marginLeft: 4 }}>/scan</code>
          </Typography>

          <br /><br />

          <Typography variant="body2">
            • or reply to an image with the command
            <code className={classes.cmd} style={{ marginLeft: 4 }}>/scan</code>
          </Typography>
        </>
      ),
    },
    {
      label: <>Optionally specify whose turn it is</>,
      content: (
        <>
          <br />
          <code className={classes.cmd}>/scan white</code>
          <br /><br />
          <code className={classes.cmd}>/scan black</code>
        </>
      ),
    },
    {
      label: <>Get instant analysis, links, and best moves</>,
    },
    {
      label: (
        <>
          Join our Telegram channel{' '}
          <Link href={settings.telegram.channel.url}>
            {settings.telegram.channel.label}
          </Link>
        </>
      ),
    },
  ];

  return (
    <Container className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h4" style={{ fontWeight: 800 }}>
          Analyze chess diagrams directly in Telegram
        </Typography>

        <Typography
          variant="subtitle1"
          style={{ marginTop: 16, color: '#eee' }}
        >
          Send a chess position from a book, puzzle, or screenshot -
          our bot recognizes it instantly and gives you analysis, links,
          and continuation ideas.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: 16, textTransform: 'none', fontWeight: 'bold' }}
          href={settings.telegram.bot.url}
        >Add {settings.telegram.bot.label}</Button>
      </div>

      <div className={classes.showcase}>
        {/* Step-by-step explanation */}
        <div className={classes.stepperContainer}>
          <Stepper
            orientation="vertical"
            style={{ backgroundColor: 'inherit' }}
          >
            {steps.map(({ label, content }, index) => (
              <Step key={index} active expanded>
                <StepLabel
                  icon={<CircleIcon />}
                  style={{ color: '#0088cc' }}
                  classes={{ label: classes.stepLabel }}
                >
                  {label}
                </StepLabel>

                {content && (
                  <StepContent>{content}</StepContent>
                )}
              </Step>
            ))}
          </Stepper>
        </div>
        
        {/* Telegram demo */}
        <div className={classes.demoContainer}>
          <TelegramChatDemo />
        </div>

      </div>
    </Container>
  );
};

export default Home;